import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Shield, ArrowLeft } from "lucide-react";

const AdminBanner = () => {
  const navigate = useNavigate();
  const isAdminSession = localStorage.getItem('admin_viewing_as_user');
  const viewingUser = JSON.parse(localStorage.getItem('shootzu_user') || '{}');

  if (!isAdminSession) return null;

  const handleReturnToAdmin = () => {
    // Restore admin session from backup
    const adminBackup = localStorage.getItem('admin_session_backup');
    if (adminBackup) {
      const adminData = JSON.parse(adminBackup);
      localStorage.setItem('shootzu_admin', adminData.token);
      localStorage.removeItem('admin_session_backup');
    } else {
      // Fallback: just set a default admin token
      localStorage.setItem('shootzu_admin', 'admin_session_token');
    }

    // Clear user session
    localStorage.removeItem('shootzu_token');
    localStorage.removeItem('shootzu_user');
    localStorage.removeItem('admin_viewing_as_user');

    // Redirect to admin dashboard
    navigate('/szadmin/dashboard');
  };

  // Get status badge color
  const getStatusColor = (status) => {
    const statusColors = {
      'new': 'bg-blue-500',
      'pending': 'bg-yellow-500',
      'approved': 'bg-green-500',
      'rejected': 'bg-red-500',
      'suspended': 'bg-gray-500'
    };
    return statusColors[(status || '').toLowerCase()] || 'bg-gray-500';
  };

  const displayName = viewingUser.full_name || `${viewingUser.first_name || ''} ${viewingUser.last_name || ''}`.trim() || viewingUser.email || 'User';
  const userStatus = (viewingUser.status || viewingUser.approval_status || 'unknown').toUpperCase();

  return (
    <>
      <div className="fixed top-0 left-0 right-0 h-10 bg-gradient-to-r from-[#7B3FF2] to-[#9059ff] text-white px-4 flex items-center justify-between z-[9999] shadow-lg">
        <div className="flex items-center gap-3">
          <Shield className="w-4 h-4" />
          <span className="font-semibold text-sm">Admin Mode: Viewing as {displayName}</span>
          <span className={`${getStatusColor(userStatus)} text-white text-xs px-2 py-0.5 rounded-full font-medium`}>
            {userStatus}
          </span>
        </div>
        <Button
          onClick={handleReturnToAdmin}
          variant="outline"
          size="sm"
          className="bg-white text-[#7B3FF2] border-white hover:bg-gray-100 h-7 text-xs"
          data-testid="return-to-admin-button"
        >
          <ArrowLeft className="w-3 h-3 mr-1" />
          Return to Admin
        </Button>
      </div>
      {/* Spacer to push page content below the fixed banner */}
      <div className="h-10" />
    </>
  );
};

export default AdminBanner;
